import http from '../../shared/http.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';
import {
  confirmAction,
  hideLoading,
  notifyError,
  notifySuccess,
  showLoading
} from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs.
const ACTIONS = {
  delete: {
    confirm: (name) => ({
      title: 'Konzern löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Konzern wird gelöscht …',
    done: 'Konzern wurde gelöscht.',
    run: (id) => http.delete(`/konzerne/${id}`)
  }
};

export function initKonzernList() {
  // Filtering, searching and paging, all without a reload. The two forms are
  // merged into one query string by the shared module, so searching keeps the
  // filter and filtering keeps the search.
  const live = initLiveList({
    results: 'konzern-list',
    path: '/konzerne',
    forms: ['konzern-filter', 'konzern-search']
  });
  if (!live) return;

  // Creating and editing happen in the shared dialog rather than on their own
  // page. The links keep their href, so a middle click still opens the real
  // page - initFormModalLinks only intercepts a plain left click.
  //
  // Delegated from document, because the "create" button sits in the page header
  // while the row's edit links arrive with each refreshed fragment.
  initFormModalLinks({
    selector: 'a[href$="/new"], a[href$="/edit"]',
    // This list can redraw itself, so a save refetches instead of reloading -
    // the filter, the page and the scroll position all stay put.
    onSaved: () => live.refresh()
  });

  const list = document.getElementById('konzern-list');

  // One delegated listener for the whole table, so rows cost nothing to add and
  // the rows that arrive with each refreshed fragment are live without
  // rebinding anything.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { konzernId, konzernName } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(konzernName)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(konzernId);
      // Refetch rather than reload: the list redraws without the deleted row
      // while the filter, the search and the scroll position all stay put.
      await live.refresh();
      hideLoading();
      notifySuccess(action.done);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      // The 409 a Konzern with members answers is the message worth showing
      // verbatim: it names how many customers are still assigned, which is what
      // the reader has to go and change.
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
